export default "__VITE_ASSET__7rwZFDQh__"